export default "__VITE_ASSET__BAZbtn_T__"